import axios from "axios";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const viewContactUsList = (payload) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "GET_CONTACT_US_LIST_REQUEST" });

      const config = {
        headers: { "Content-Type": "application/json" },
      };

      const { data } = await axios.post(
        `${BASE_URL}/contact-us/list`,
        payload,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "GET_CONTACT_US_LIST_SUCCESS", payload: data });
      } else {
        dispatch({ type: "GET_CONTACT_US_LIST_FAILED", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "GET_CONTACT_US_LIST_FAILED",
        payload: error?.response?.data?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};